var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/Providers/index.tsx";
import React from 'react';
import { ParallaxProvider, config } from '@adc/parallax-component-library';
import { useTheme } from 'Hooks';
import { store } from 'Utilities/store';
const Providers = ({
  children
}) => {
  const {
    theme
  } = useTheme();
  const isTestEnvironment = store.getState().env.isTestEnvironment;
  return /*#__PURE__*/React.createElement(ParallaxProvider, {
    config: config,
    locale: "en-US",
    dir: "ltr",
    isTestEnvironment: Boolean(isTestEnvironment),
    defaultTheme: theme,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  }, children);
};
export default Providers;